/* DataEgress.tsx generated by @compiled/babel-plugin v0.36.0 */
/* eslint-disable max-lines-per-function */
import { ax, ix, CC, CS } from "@compiled/react/runtime";
import DataFlowIcon from '@atlaskit/icon/core/data-flow';
import GlobeIcon from '@atlaskit/icon/core/globe';
import { Box, Stack, xcss } from '@atlaskit/primitives';
import { AccordionCollapsedEvent, AccordionExpandedEvent, AccordionGroupCollapsedEvent, AccordionGroupExpandedEvent, ANALYTICS_ACTION_COLLAPSED, ANALYTICS_ACTION_EXPANDED, useAnalyticsEvents } from '@atlassian/mpac-analytics';
import { AccordionItemTriggerContent, AccordionV2, BodySmall } from '@atlassian/mpac-primitives';
import { AppNetworkPermissionType } from '@atlassian/mpac-types/graphql-gateway-types';
import { AccordionError } from '../AccordionError/AccordionError';
import { AccordionLoading } from '../AccordionLoading/AccordionLoading';
import { formatEgressAddress } from '../analyticsAndEgressUtil';
import { ANALYTICS_EVENT_CONTAINER_TWO_STEP_INSTALL_DIALOG, ANALYTICS_SUBJECT_ID_TWO_STEP_INSTALL_DIALOG_DATA_MANAGEMENT_ACCORDION, ANALYTICS_SUBJECT_ID_TWO_STEP_INSTALL_DIALOG_DATA_MANAGEMENT_ACCORDION_GROUP } from '../events';
import { DataResidency } from './DataResidency';
import { jsxs as _jsxs, jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
const _2 = "._19pk1b66{margin-top:var(--ds-space-050,4px)}";
const _ = "._syaz1gjq{color:var(--ds-text-subtle,#44546f)}";
const styles = xcss({
  margin: 'space.0',
  gap: 'space.100',
  display: 'flex',
  flexDirection: 'column'
});
const messagesMappingForExternalEgress = [{
  type: AppNetworkPermissionType.Frames,
  message: 'Load external frames:'
}, {
  type: AppNetworkPermissionType.Fonts,
  message: 'Load fonts:'
}, {
  type: AppNetworkPermissionType.Images,
  message: 'Load images'
}, {
  type: AppNetworkPermissionType.Media,
  message: 'Load media:'
}, {
  type: AppNetworkPermissionType.Styles,
  message: 'Load styles:'
}, {
  type: AppNetworkPermissionType.Navigation,
  message: 'Load navigation:'
}];
const subtleTextColor = null;
const webTriggerEgressStyle = null;
export const EgressAddressListRenderer = _ref => {
  let {
    egressAddresses,
    categorySubHeading
  } = _ref;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [categorySubHeading ? /*#__PURE__*/_jsxs(CC, {
      children: [/*#__PURE__*/_jsx(CS, {
        children: [_]
      }), /*#__PURE__*/_jsx(BodySmall, {
        className: ax(["_syaz1gjq"]),
        children: categorySubHeading
      })]
    }) : null, /*#__PURE__*/_jsx(Box, {
      as: "ul",
      paddingInlineStart: "space.300",
      paddingInlineEnd: "space.600",
      paddingBlockStart: "space.100",
      paddingBlockEnd: "space.100",
      xcss: styles,
      children: formatEgressAddress(egressAddresses).map(address => /*#__PURE__*/_jsx(Box, {
        as: "li",
        children: address
      }, address))
    })]
  });
};
const CORE_EGRESS_TYPES = [AppNetworkPermissionType.FetchBackendSide, AppNetworkPermissionType.FetchClientSide, AppNetworkPermissionType.Scripts];
export const DataEgress = _ref2 => {
  let {
    egresses,
    roaStatus: isRoaApp,
    queryError,
    hasWebtriggerEgress,
    isForgeApp,
    isLoading
  } = _ref2;
  const fireAnalyticsEvent = useAnalyticsEvents();
  const coreEgressData = CORE_EGRESS_TYPES.reduce((acc, type) => {
    const egress = egresses === null || egresses === void 0 ? void 0 : egresses[type];
    if (egress) {
      return [...acc, ...egress];
    }
    return acc;
  }, []);
  if (isLoading) {
    return /*#__PURE__*/_jsx(AccordionLoading, {});
  }
  const areEgressedEmpty = Object.values(egresses || {}).every(egress => egress.length === 0) && !hasWebtriggerEgress;
  const handleDataManagementAccordionItemExpand = key => {
    fireAnalyticsEvent({
      eventType: AccordionExpandedEvent,
      event: ANALYTICS_ACTION_EXPANDED,
      eventContainer: ANALYTICS_EVENT_CONTAINER_TWO_STEP_INSTALL_DIALOG,
      actionSubjectId: ANALYTICS_SUBJECT_ID_TWO_STEP_INSTALL_DIALOG_DATA_MANAGEMENT_ACCORDION,
      attributes: {
        section: key
      }
    });
  };
  const handleDataManagementAccordionItemCollapse = key => {
    fireAnalyticsEvent({
      eventType: AccordionCollapsedEvent,
      event: ANALYTICS_ACTION_COLLAPSED,
      eventContainer: ANALYTICS_EVENT_CONTAINER_TWO_STEP_INSTALL_DIALOG,
      actionSubjectId: ANALYTICS_SUBJECT_ID_TWO_STEP_INSTALL_DIALOG_DATA_MANAGEMENT_ACCORDION,
      attributes: {
        section: key
      }
    });
  };
  const handleExpandAll = () => {
    fireAnalyticsEvent({
      eventType: AccordionGroupExpandedEvent,
      event: ANALYTICS_ACTION_EXPANDED,
      eventContainer: ANALYTICS_EVENT_CONTAINER_TWO_STEP_INSTALL_DIALOG,
      actionSubjectId: ANALYTICS_SUBJECT_ID_TWO_STEP_INSTALL_DIALOG_DATA_MANAGEMENT_ACCORDION_GROUP,
      attributes: {
        section: 'Data management'
      }
    });
  };
  const handleCollapseAll = () => {
    fireAnalyticsEvent({
      eventType: AccordionGroupCollapsedEvent,
      event: ANALYTICS_ACTION_COLLAPSED,
      eventContainer: ANALYTICS_EVENT_CONTAINER_TWO_STEP_INSTALL_DIALOG,
      actionSubjectId: ANALYTICS_SUBJECT_ID_TWO_STEP_INSTALL_DIALOG_DATA_MANAGEMENT_ACCORDION_GROUP,
      attributes: {
        section: 'Data management'
      }
    });
  };
  const renderAccordionEgresses = () => {
    return /*#__PURE__*/_jsxs(Stack, {
      space: "space.300",
      children: [/*#__PURE__*/_jsxs(Box, {
        padding: "space.0",
        children: [coreEgressData.length > 0 ? /*#__PURE__*/_jsx(EgressAddressListRenderer, {
          egressAddresses: coreEgressData
        }) : null, hasWebtriggerEgress && /*#__PURE__*/_jsxs(CC, {
          children: [/*#__PURE__*/_jsx(CS, {
            children: [_, _2]
          }), /*#__PURE__*/_jsx(BodySmall, {
            className: ax([coreEgressData.length > 0 && "_syaz1gjq _19pk1b66"]),
            children: "This app uses web triggers that may share data to and receive data from outside of Atlassian."
          })]
        })]
      }), messagesMappingForExternalEgress.map(_ref3 => {
        let {
          type,
          message
        } = _ref3;
        const egress = egresses === null || egresses === void 0 ? void 0 : egresses[type];
        if (!(egress !== null && egress !== void 0 && egress.length)) {
          return null;
        }
        return /*#__PURE__*/_jsx(Box, {
          children: /*#__PURE__*/_jsx(EgressAddressListRenderer, {
            categorySubHeading: message,
            egressAddresses: egress
          })
        }, type);
      })]
    });
  };
  const renderAccordionContent = () => {
    if (queryError) {
      return /*#__PURE__*/_jsx(AccordionError, {
        label: "Data management error"
      });
    }
    if (!isForgeApp) {
      return /*#__PURE__*/_jsxs(CC, {
        children: [/*#__PURE__*/_jsx(CS, {
          children: [_]
        }), /*#__PURE__*/_jsx(BodySmall, {
          className: ax(["_syaz1gjq"]),
          children: "This app is not hosted on Atlassian and may share data to undisclosed domains."
        })]
      });
    }
    if (areEgressedEmpty || isRoaApp) {
      return /*#__PURE__*/_jsxs(CC, {
        children: [/*#__PURE__*/_jsx(CS, {
          children: [_]
        }), /*#__PURE__*/_jsx(BodySmall, {
          className: ax(["_syaz1gjq"]),
          children: "This app will store and process data exclusively within Atlassian products and services. Some exceptions may apply, depending on the settings configured for analytics and logs."
        })]
      });
    }
    return renderAccordionEgresses();
  };
  return /*#__PURE__*/_jsx(AccordionV2, {
    mainTitle: "Data management",
    onExpandAll: handleExpandAll,
    onCollapseAll: handleCollapseAll,
    onExpandItem: handleDataManagementAccordionItemExpand,
    onCollapseItem: handleDataManagementAccordionItemCollapse,
    showExpandAll: isRoaApp,
    items: [{
      heading: () => /*#__PURE__*/_jsx(AccordionItemTriggerContent, {
        title: "Data storage, sharing, receiving, and processing",
        icon: /*#__PURE__*/_jsx(DataFlowIcon, {
          label: "app",
          color: "var(--ds-icon-disabled, rgba(9, 30, 66, 0.31))"
        })
      }),
      content: renderAccordionContent,
      key: 'data-management',
      ariaLabel: 'Data storage, sharing, receiving, and processing details'
    }, ...(isRoaApp ? [{
      heading: () => /*#__PURE__*/_jsx(AccordionItemTriggerContent, {
        title: "Data residency",
        icon: /*#__PURE__*/_jsx(GlobeIcon, {
          label: "app",
          color: "var(--ds-icon-disabled, rgba(9, 30, 66, 0.31))"
        })
      }),
      content: () => /*#__PURE__*/_jsx(DataResidency, {
        hasError: queryError,
        isLoading: isLoading
      }),
      key: 'data-residency',
      ariaLabel: 'Data residency details'
    }] : [])]
  });
};